import type { FaireProductEntity } from "../../entity_types/product";

export const p_kd86dpdw4w: FaireProductEntity = {
  token: "p_kd86dpdw4w",
  type: "product",
  name: "THRASHER SKATE MAG BLACK WALLET",
  brandToken: "b_u8merz42xh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1c6b558ed6034e232255a2e1cf099fb20a3d428a4ca19bbbf5fb127d1f9b1a61.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0de2091ec1ee489936ba22d3095360af4d7b0588251339fe57ff5a76b7f95ad7.jpeg",
  ],
  priceDollars: 21.5,
  description:
    "Carry your cash and cards in style with this lightweight Thrasher Skate Mag trifold wallet. Built from durable nylon with a secure velcro closure, it keeps your essentials organized with dedicated card slots. Compact enough to slip into any pocket, perfect for skate sessions, street runs, or just keeping your lunch money safe.\n",
  tags: [],
  msrpDollars: 43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:58.441Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
